export const wifi = () => (
  <path
    d="M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0M12 20h.01"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
